import Item from '../../canvas-timeline/canvas_timeline_item';
import {ITEM_TYPE, drawRectangle, getTextColor, getTrimmedText, getWeekdaysBetweenDates} from '../../canvas-timeline/canvas_timeline_util';
import Util from '../../../../forecast-app/shared/util/util';

class TaskAllocationItem extends Item {
	constructor(data) {
		super(ITEM_TYPE.PROJECT_SCHEDULING_TASK_ALLOCATION, data);
	}
	draw(canvasContext) {
		const {data, height} = this;
		const {color, totalEstimates, dates, pixelsPerDay, isHourEstimated, intl} = data;
		//items drawing
		const startDates = dates
			.slice()
			.sort((a, b) => a.startDate - b.startDate)
			.map(dateObj => dateObj.startDate);
		const endDates = dates
			.slice()
			.sort((a, b) => b.endDate - a.endDate)
			.map(dateObj => dateObj.endDate);
		const earliestStartDate = startDates.length ? startDates[0] : null;
		const latestEndDate = endDates.length ? endDates[0] : null;
		const weekendDaysWithin = data.hideWeekends ? getWeekdaysBetweenDates(earliestStartDate, latestEndDate, null, false, false)[5] + getWeekdaysBetweenDates(earliestStartDate, latestEndDate, null, false, false)[6] : 0;
		const totalWidth = latestEndDate && earliestStartDate ? (latestEndDate + 1 - earliestStartDate - weekendDaysWithin) * pixelsPerDay : 0;
		const sortedDates = dates.slice().sort((a, b) => {
			if (a.startDate < b.startDate) return -1;
			if (b.startDate < a.startDate) return 1;
			return 0;
		});
		const filledItems = [];
		sortedDates
			.filter(obj => obj.isFilled)
			.forEach((dateObj, index) => {
				const sectionWidth = (dateObj.endDate - dateObj.startDate + 1) * pixelsPerDay;
				const dayBetween = dateObj.startDate - earliestStartDate;
				const extraXCoor = earliestStartDate ? dayBetween * pixelsPerDay : 0;
				filledItems.push({
					x: data.x + extraXCoor,
					y: data.y,
					width: sectionWidth,
					height: height,
					startDate: dateObj.startDate,
					endDate: dateObj.endDate,
				});
			});
		const canvasWidth = canvasContext.canvas.width / window.devicePixelRatio;
		//draw rectangle with earliest start date, latest end date and give it 0.7 opacity to fill all empty spaces
		drawRectangle(canvasContext, data.x, data.y + 2, totalWidth, height - 4, {
			backgroundColor: color,
			backgroundOpacity: 0.7,
			borderTopLeftRadius: 10,
			borderBottomLeftRadius: 10,
			borderTopRightRadius: 10,
			borderBottomRightRadius: 10,
		});
		canvasContext.save();
		canvasContext.clip();

		let fragmentX = null;
		let fragmentStartDate = null;
		let fragmentEndDate = null;

		for (const filledItem of filledItems) {
			if (fragmentStartDate === null) {
				fragmentX = filledItem.x;
				fragmentStartDate = filledItem.startDate;
				fragmentEndDate = filledItem.endDate;
				continue;
			}
			if (filledItem.startDate <= fragmentEndDate + 1 && filledItem.endDate > fragmentEndDate) {
				fragmentEndDate = filledItem.endDate;
			} else {
				drawRectangle(canvasContext, fragmentX, data.y + 2, (fragmentEndDate - fragmentStartDate + 1) * pixelsPerDay, height - 4, {
					backgroundColor: color,
					backgroundOpacity: 1,
				});
				fragmentX = filledItem.x;
				fragmentStartDate = filledItem.startDate;
				fragmentEndDate = filledItem.endDate;
			}
		}

		if (fragmentStartDate) {
			drawRectangle(canvasContext, fragmentX, data.y + 2, (fragmentEndDate - fragmentStartDate + 1) * pixelsPerDay, height - 4, {
				backgroundColor: color,
				backgroundOpacity: 1,
			});
		}
		canvasContext.restore();
		//text drawing
		let text;
		if (isHourEstimated) {
			text = Util.convertMinutesToFullHour(totalEstimates * 60, intl);
		} else {
			text = intl.formatMessage({id: 'common.x_points'}, {points: totalEstimates});
		}
		const textWidth = canvasContext.measureText(text).width;
		const textXCoord = data.x + data.width - 16 > canvasWidth ? canvasWidth - (16 + textWidth) : data.x + data.width - (16 + textWidth);
		if (data.width > 32 && data.x + 16 < textXCoord) {
			const textColor = getTextColor(color);
			canvasContext.fillStyle = textColor;
			canvasContext.font = '400 12px ' + Util.getFontFamily();
			const formattedTaskName = getTrimmedText(canvasContext, text, data.width - 32);
			canvasContext.fillText(formattedTaskName, textXCoord, data.y + 22);
		}
	}
}
export default TaskAllocationItem;
